import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import { PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startFormLoading,
  stopFormLoading,
  startPRLoading,
  stopPRLoading,
} from './loader';
import { setValidation } from './validation';

const fetchItemsDone = (payload) => ({
  type: TYPES.FETCH_ITEMS_DONE,
  payload,
});

export const fetchItems = () => (dispatch) => {
  dispatch(startPRLoading());
  const user = JSON.parse(localStorage.getItem('user'));
  let roleName = '';
  if (user && user.id) {
    roleName = user.roles[0].role.name;
  }
  return client.getItems(user.id, roleName).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        let filterData = responsejson.map((rs) => {
          if (rs.properties.length > 0) {
            let names = '';
            rs.properties.map((ps, index) => {
              return (names =
                names +
                ps.name +
                (rs.properties.length - 1 === index ? '' : ', '));
            });
            return { ...rs, propertyNames: names };
          } else {
            return { ...rs, propertyNames: '' };
          }
        });
        dispatch(fetchItemsDone(filterData));
        dispatch(stopPRLoading());
      });
    } else {
      dispatch(stopPRLoading());
    }
  });
};

const saveItemDone = (payload) => ({
  type: TYPES.SAVE_ITEM_DONE,
  payload,
});

export const saveItem = (item) => (dispatch) => {
  dispatch(startFormLoading());
  return client.saveItem(item).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(setValidation('Item'));
        toast.success('ⓘ Item has been added.', {
          autoClose: 12000,
          position: 'top-center',
        });
        if (responsejson.data !== null) {
          let names = '';
          if (
            responsejson.data.properties &&
            responsejson.data.properties.length > 0
          ) {
            responsejson.data.properties.map((ps, index) => {
              return (names =
                names +
                ps.name +
                (responsejson.data.properties.length - 1 === index
                  ? ''
                  : ', '));
            });
          }
          dispatch(
            saveItemDone({ ...responsejson.data, propertyNames: names })
          );
        }
      });
    } else {
    }
  });
};

const deleteItemDone = (payload) => ({
  type: TYPES.DELETE_ITEM_DONE,
  payload,
});
toast.configure();
export const deleteItem = (id, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client.deleteItem(id).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        toast.success(' ⓘ  Item has been deleted.', {
          autoClose: 12000,
          position: 'top-center',
        });
        if (history) {
          history.push(PATHS.ITEMS_LIST);
        }
        dispatch(deleteItemDone(id));
      });
    } else {
      // alert('Something Went Wrong !')
    }
  });
};

const updateItemDone = (payload) => ({
  type: TYPES.UPDATE_ITEM_DONE,
  payload,
});

export const updateItem = (data, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client.updateItem(data).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      toast.success('ⓘ Item has been updated.', {
        autoClose: 12000,
        position: 'top-center',
      });
      if (history) {
        history.push(PATHS.ITEMS_LIST);
      }
      response.json().then((responsejson) => {
        dispatch(setValidation('Item'));
        let names = '';
        if (
          responsejson.data.properties &&
          responsejson.data.properties.length > 0
        ) {
          responsejson.data.properties.map((ps, index) => {
            return (names =
              names +
              ps.name +
              (responsejson.data.properties.length - 1 === index ? '' : ', '));
          });
        }
        dispatch(
          updateItemDone({ ...responsejson.data, propertyNames: names })
        );
      });
    } else {
      dispatch(setValidation('Item'));
      toast.error('🚫 Something Went Wrong Please retry', {
        autoClose: 12000,
        position: 'top-center',
      });
    }
  });
};

